import {AvalancheRemoveWinsState} from '@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheRemoveWinsState';
import {GameAvalancheReelEvents} from 'src/avalanche/GameAvalancheReelEvents';
import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameAvalancheReelsEvents} from 'src/avalanche/GameAvalancheReelsEvents';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {WildMeterEvents} from 'src/wildmeter/WildMeterEvents';

export class GameAvalancheRemoveWinsState extends AvalancheRemoveWinsState {
	protected static readonly BEFORE_REMOVE_TIMEOUT: number = 75;

	protected setupEvents(): void {
		super.setupEvents();

		this.on(WildMeterEvents.WIN_METER_WILDS_ANIMATIONS_FINISHED, this.onWinMeterWildsAnimationFinished);
	}

	public onEnterState(): void {
		this.emit(GameAvalancheReelEvents.REMOVING_STARTED);
		this.startSymbolsRemoving();
	}

	protected onWinMeterWildsAnimationFinished(): void {
		this.module.gotoState(AvalancheReelsModule.ADD_SYMBOLS_STATE);
	}

	protected startSymbolsRemoving(): void {
		const delay = GameAvalancheRemoveWinsState.BEFORE_REMOVE_TIMEOUT;

		this.module.timeUtils.createTimer(() => {
				const gameLogic: GameRecodeLogic = this.module.logic as GameRecodeLogic;

				(this.view as GameAvalancheReelsView).removeSymbolsOnAvalancheWithSound(
					gameLogic.getSpinResult().symbolsToRemove, gameLogic.getSpinWin(), gameLogic.getTotalBet());

				this.emit(GameAvalancheReelsEvents.WIN_SYMBOLS_EXPLOSION_STARTED, gameLogic.getSpinResult().symbolsToRemove);
			},
			delay,
		);
	}

	protected onRemovingFinished(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;

		const wildWinPositions: SymbolPosition[] = logic.getCurrentRoundWinningWilds();
		if (wildWinPositions.length <= 0) {
			super.onRemovingFinished();
		}
	}

	protected finishRemoving(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;

		const wildWinPositions: SymbolPosition[] = logic.getCurrentRoundWinningWilds();
		if (wildWinPositions.length <= 0) {
			super.finishRemoving();
		}
	}
}



// WEBPACK FOOTER //
// ./src/avalanche/states/GameAvalancheRemoveWinsState.ts